import {
  ChatMessageRole,
  FileAttachment,
  NavigationRoute,
  ResponseSegment,
} from 'further-types/lp/ai-agent';
import { CalendarTime } from 'further-ui/utils';

export type NavigationItem = {
  route: NavigationRoute;
  label: string;
  description?: string;
};

export type PendingInvoice = {
  base64: string;
  mediaType: FileAttachment['mediaType'];
  fileName: string;
  uploadedPath: string;
  uploadedName: string;
  uploadedPreview: string;
};

export type ChatMessageAgent = {
  role: ChatMessageRole.Assistant;
  segments: Array<ResponseSegment>;
  pendingInvoice: PendingInvoice | null;
  timestamp: CalendarTime;
};
export type ChatMessage =
  | {
      role: ChatMessageRole.User;
      content: string;
      fileName?: string;
      timestamp: CalendarTime;
    }
  | ChatMessageAgent
  | {
      role: ChatMessageRole.Action;
      content: string;
    };

export type ResizeDir = 'n' | 's' | 'e' | 'w' | 'ne' | 'nw' | 'se' | 'sw';

export const CREATE_ROUTES = new Set<NavigationRoute>([
  NavigationRoute.IncomeAdd,
  NavigationRoute.ExpenseAdd,
  NavigationRoute.InvestmentCreate,
  NavigationRoute.RealisationCreate,
  NavigationRoute.CapitalActionCreate,
  NavigationRoute.ManualJournalCreate,
  NavigationRoute.HoldingsCreate,
  NavigationRoute.EqualisationsAdd,
  NavigationRoute.PartnerTransfersCreate,
]);

export const INITIAL_WIDTH = 480;
export const INITIAL_HEIGHT = 620;
export const MIN_WIDTH = 360;
export const MIN_HEIGHT = 300;
